// extracted by mini-css-extract-plugin
module.exports = {"picture":"Picture_picture__3Ca2R","media":"Picture_media__SP1zD"};